import '@babel/polyfill';
import 'reflect-metadata';
import 'core-js/es6/map';
import 'core-js/es6/symbol';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vee-validate';
import '@/filters/date';
import '@/filters/numeric';
import App from '@/pages/app/Index.vue';
Vue.config.productionTip = false;
new Vue({
    router: router,
    store: store,
    vuetify: vuetify,
    render: function (h) { return h(App); },
}).$mount('#app');
